@let hasProjectedTags = !!projectedTags().length;

<label
  [for]="labelId()"
  class="flex h-full min-h-[inherit] flex-col"
>
  <!-- Заголовок и внешняя ссылка -->
  <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
  <!-- Основной контейнер editable-div -->
  <div
    class="editable-div_wrapper flex h-full min-h-[inherit] items-center"
    [class.focus-visible]="isFocused()"
    [class.error]="hasError() || showErrorOnDemand()"
    [class.readonly]="readonly()"
    (click)="setFocusOnInput()"
  >
    <!-- ng-content для добавления иконки слева -->
    <ng-content select="[content-left]" />

    <!-- Содержимое editable-div -->
    <div class="editable-div_container relative min-h-[inherit] size-full overflow-hidden">
      <!-- Многострочный placeholder -->
      <div
        class="editable-div_placeholder"
        [class.hidden]="(value() || isFocused() || hasProjectedTags) && !isPlaceholderVisible()"
        [innerHTML]="formattedPlaceholder()"
      ></div>

      <div class="editable-div_inner-wrapper flex flex-wrap gap-2 h-full min-h-[inherit]">
        <!-- Слот для проецирования тэгов -->
        <ng-content select="[projected-tags]"></ng-content>

        <div
          #editableDiv
          class="editable-div relative z-10 min-h-[inherit] flex-1"
          [class.no-projected-tags]="!hasProjectedTags"
          [id]="labelId()"
          [contentEditable]="!disabled()"
          [attr.autocomplete]="autocomplete()"
          [attr.maxlength]="maxLines()"
          [attr.readonly]="readonly()"
          [attr.required]="isRequired()"
          (input)="onInput($event)"
          (focus)="onFocus($event)"
          (blur)="onBlur($event)"
          (paste)="onPaste($event)"
          (dragstart)="onDragStart($event)"
          (dragend)="onDragEnd()"
          (dragover)="onDragOver($event)"
          (drop)="onDrop($event)"
          (keydown)="keydownEvent.emit($event)"
        ></div>
      </div>
    </div>

    <!-- Дополнительные кнопки -->
    <ng-container *ngTemplateOutlet="buttonActionsTemplate"></ng-container>

    <!-- ng-content для добавления иконки справа вверху-->
    <ng-content select="[content-right]" />
  </div>

  <!-- Сообщение об ошибке -->
  <ng-container *ngTemplateOutlet="errorMessageTemplate"></ng-container>
</label>

<!-- ng-content для добавления иконки справа внизу-->
<div class="absolute bottom-2 right-2 z-[11] size-fit">
  <ng-content select="[content-bottom-right]" />
</div>

<!-- Шаблон заголовка -->
<ng-template #titleTemplate>
  <div class="flex items-center justify-between">
    @if (title(); as title) {
      <div class="flex items-center pb-2">
        <span class="title"> {{ title }} </span>
        @if (isRequired()) {
          <span class="asterisk"> * </span>
        }
        <!-- Проекция кнопки информации -->
        <ng-content select="[info-button]"></ng-content>
      </div>
    }

    <!-- Внешняя ссылка через ng-content -->
    <ng-content select="[external-link]"></ng-content>
  </div>
</ng-template>

<!-- Шаблон для кнопок действий -->
<ng-template #buttonActionsTemplate>
  @if (copyable()) {
    <ng-container *ngTemplateOutlet="copyButtonTemplate"></ng-container>
  }
</ng-template>

<!-- Шаблон для кнопки копирования -->
<ng-template #copyButtonTemplate>
  <div
    class="input-btn ml-1"
    [class.disabled]="!value()"
  >
    @if (showCopyNotification()) {
      <div
        class="copy-notification text-xs font-normal text-green-400"
        (animationend)="showCopyNotification.set(false)"
      >
        copied
      </div>
    } @else {
      <button>
        <i class="ph ph-copy text-base/4"></i>
      </button>
    }
  </div>
</ng-template>

<!-- Шаблон для сообщения об ошибке -->
<ng-template #errorMessageTemplate>
  @if (hasError()) {
    <div class="error-message mt-1 text-xs text-red-500">
      {{ errorMessage() }}
    </div>
  }
</ng-template>
